import React from 'react';
import 'stream-chat-react';
import { noop } from '../../../utils/index.js';
import '../../../chat_context.js';
import { useChatApi } from '../../../hooks/use_chat_api.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';

const useChatGroups = (channel) => {
    const [groups, setGroups] = React.useState([]);
    const api = useChatApi();
    React.useEffect(() => {
        if (!channel)
            return;
        api.chat
            .get(`me/conversations/${channel.id}/groups`)
            .then(setGroups)
            .catch(noop);
    }, [channel]);
    return groups.reduce((acc, group) => {
        var _a, _b, _c;
        acc[_a = group.source_app_name] || (acc[_a] = {});
        (_b = acc[group.source_app_name])[_c = group.source_type] || (_b[_c] = []);
        acc[group.source_app_name][group.source_type].push(group);
        return acc;
    }, {});
};

export { useChatGroups };
//# sourceMappingURL=use_chat_groups.js.map
